module.exports = __webpack_public_path__ + "img/logo-ixasia-index.69ef6b83.png";